import { ReactElement, useMemo } from 'react';
import { useOpco } from '../../../hooks';
import { Opco } from '../../../models';

export function BrandLogo(): ReactElement {
	const opco: Opco = useOpco();

	const logoUrl: string = useMemo<string>(() => {
		switch (opco) {
			case Opco.Noordhoff:
				return 'DE_DIGITALE_ATLAS_DIAP_RGB.svg';
			case Opco.Plantyn:
				return 'dedigitaleatlas.png';
		}
	}, [opco]);

	const opcoName: string = useMemo<string>(() => {
		switch (opco) {
			case Opco.Noordhoff:
				return 'bosatlas';
			case Opco.Plantyn:
				return 'algemene wereldatlas';
		}
	}, [opco]);

	return (
		<img
			className="brand-logo"
			src={`${process.env.PUBLIC_URL}/images/${logoUrl}`}
			alt={`${opcoName} logo`}
		/>
	);
}
